// const BACKEND_BASE_URL = "http://127.0.0.1:8000/api/";
// export { BACKEND_BASE_URL };
// export const fileUrl = "http://127.0.0.1:8000";

const BACKEND_BASE_URL = "https://secure.iisplbd.com/api/";
export { BACKEND_BASE_URL };
export const fileUrl = "https://secure.iisplbd.com";
